// USER-CODE-ORIGIN security review 8 / r2 note 5: the canvas listens for two
// install notices on `window` ('symbols:marketplace-installed',
// 'symbols:integration-installed'). Their only senders are the marketplace
// functions of THIS app, which post to their OWN window
// (`window.postMessage(…, '*')` in marketplace/functions/index.js). A
// user-code tile is a sandboxed frame on this page and can `parent
// .postMessage` too (origin "null"), and a published *.symbo.ls site runs user
// code. So a notice counts only when it comes from this very window, on this
// very origin. Self-contained (frank serializes it alone).
export function isTrustedInstallMessage(ev) {
  if (typeof window === 'undefined' || !ev) return false
  if (ev.source !== window) return false
  const here = window.location && window.location.origin
  return typeof ev.origin === 'string' && !!here && ev.origin === here
}
